// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ValueYourTradeInfoSlide[data-v-7a5dc6b9] {
  height: 100%;
  width: 0%;
  position: fixed;
  z-index: 1;
  bottom: 0;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  box-shadow: inset -9px -20px 11px 0px #eeeeeefc, -3px -3px 3px 0px #eeeeee52;
  border-top: 1px solid rgba(0, 0, 0, 0.095) !important;
  overflow-y: auto;
}
.ValueYourTradeInfoSlide.position-left-alignment[data-v-7a5dc6b9] {
  left: 25%;
}
.ValueYourTradeInfoSlide.position-right-alignment[data-v-7a5dc6b9] {
  right: 25%;
}
.ValueYourTradeInfoSlide .nav_header[data-v-7a5dc6b9] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 5vh;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  z-index: 99;
  background: #fff;
}
.ValueYourTradeInfoSlide .nav_header h5[data-v-7a5dc6b9] {
  font-size: 12px;
  font-weight: 600;
}
.ValueYourTradeInfoSlide .nav_header i[data-v-7a5dc6b9] {
  font-size: 11px !important;
  color: #d9d9d9;
  transition: transform 1s ease;
  display: block;
}
.widget_open_toggle .icon_btn[data-v-7a5dc6b9] {
  position: fixed;
  top: 30%;
  width: 25px;
  height: 5vh;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px 0 0 5px;
  cursor: pointer;
}
.widget_open_toggle .icon_btn.position-left-alignment[data-v-7a5dc6b9] {
  left: 25%;
  transform: rotate(180deg);
}
.widget_open_toggle .icon_btn.position-right-alignment[data-v-7a5dc6b9] {
  right: 25%;
}
.widget_open_toggle .icon_btn i[data-v-7a5dc6b9] {
  animation: right-7a5dc6b9 1s infinite;
  display: block;
  color: #fff !important;
}
@keyframes right-7a5dc6b9 {
0% {
    transform: translateX(5px);
    opacity: 0;
}
100% {
    transform: translateX(0px);
    opacity: 1;
}
}
@keyframes left-7a5dc6b9 {
0% {
    transform: translateX(-5px);
    opacity: 0;
}
100% {
    transform: translateX(0px);
    opacity: 1;
}
}
.ValueYourTradeInfoSlide[data-v-7a5dc6b9]::-webkit-scrollbar {
  width: 3px;
}
.ValueYourTradeInfoSlide[data-v-7a5dc6b9]::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.ValueYourTradeInfoSlide[data-v-7a5dc6b9]::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}
.ValueYourTradeInfoSlide[data-v-7a5dc6b9]::-webkit-scrollbar-thumb:hover {
  background: #888;
}
.overlay_section[data-v-7a5dc6b9] {
  position: fixed;
  height: 100vh;
  z-index: -1;
  clear: both;
  bottom: 0;
  left: 0;
}
.widget_close_toggle .icon_close_btn[data-v-7a5dc6b9] {
  width: 25px;
  height: 5vh;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px 0 0 5px;
  cursor: pointer;
}
.widget_close_toggle .icon_close_btn i[data-v-7a5dc6b9] {
  font-size: 13px;
  display: block;
  color: #fff !important;
}
.widget_close_toggle .icon_close_btn.position-left-alignment i[data-v-7a5dc6b9] {
  transform: rotate(180deg);
}
@media (min-width: 1900px) {
.ValueYourTradeInfoSlide .nav_header h5[data-v-7a5dc6b9] {
    font-size: 16px;
}
}
@media (min-width: 2500px) {
.ValueYourTradeInfoSlide .nav_header h5[data-v-7a5dc6b9] {
    font-size: 20px;
}
}
.scroll_to_bottom[data-v-7a5dc6b9] {
  position: sticky;
  max-width: 50px;
  text-align: center;
  margin: 10px auto;
  bottom: 5px;
  color: #fff;
  font-size: 13px;
  border-radius: 5px;
  cursor: pointer;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/SlideOutPanel/SlideOutPanel.vue","webpack://./SlideOutPanel.vue"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4EAAA;EACA,qDAAA;EACA,gBAAA;ACAF;ADEE;EACE,SAAA;ACAJ;ADGE;EACE,UAAA;ACDJ;ADjBA;EAsBI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;ACFJ;AD5BA;EAiCM,eAAA;EACA,gBAAA;ACFN;ADhCA;EAsCM,0BAAA;EACA,cAAA;EACA,6BAAA;EACA,cAAA;ACHN;ADQA;EAEI,eAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,eAAA;ACPJ;ADSI;EACE,SAAA;EACA,yBAAA;ACPN;ADUI;EACE,UAAA;ACRN;ADXA;EAuBM,qCAAA;EACA,cAAA;EACA,sBAAA;ACTN;ADYI;AACE;IACE,0BAAA;IACA,UAAA;ACVN;ADaI;IACE,0BAAA;IACA,UAAA;ACXN;AACF;ADcI;AACE;IACE,2BAAA;IACA,UAAA;ACZN;ADeI;IACE,0BAAA;IACA,UAAA;ACbN;AACF;ADkBA;EACE,UAAA;AChBF;ADmBA;EACE,mBAAA;ACjBF;ADoBA;EACE,gBAAA;EACA,mBAAA;AClBF;ADqBA;EACE,gBAAA;ACnBF;ADsBA;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;ACpBF;ADuBA;EAEI,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,eAAA;ACtBJ;ADcA;EAWM,eAAA;EACA,cAAA;EACA,sBAAA;ACtBN;ADyBI;EAEI,yBAAA;ACxBR;AD8BA;AACE;IAEI,eAAA;AC7BJ;AACF;ADiCA;AACE;IAEI,eAAA;AChCJ;AACF;ADoCA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AClCF","sourcesContent":["\n.ValueYourTradeInfoSlide {\n  height: 100%;\n  width: 0%;\n  position: fixed;\n  z-index: 1;\n  bottom: 0;\n  background-color: #fff;\n  overflow-x: hidden;\n  transition: 0.5s;\n  box-shadow: inset -9px -20px 11px 0px #eeeeeefc, -3px -3px 3px 0px #eeeeee52;\n  border-top: 1px solid rgba(0, 0, 0, 0.095) !important;\n  overflow-y: auto;\n\n  &.position-left-alignment {\n    left: 25%;\n  }\n\n  &.position-right-alignment {\n    right: 25%;\n  }\n\n  .nav_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 5vh;\n    border-bottom: 1px solid #eee;\n    position: sticky;\n    top: 0;\n    z-index: 99;\n    background: #fff;\n\n    h5 {\n      font-size: 12px;\n      font-weight: 600;\n    }\n\n    i {\n      font-size: 11px !important;\n      color: #d9d9d9;\n      transition: transform 1s ease;\n      display: block;\n    }\n  }\n}\n\n.widget_open_toggle {\n  .icon_btn {\n    position: fixed;\n    top: 30%;\n    width: 25px;\n    height: 5vh;\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px 0 0 5px;\n    cursor: pointer;\n\n    &.position-left-alignment {\n      left: 25%;\n      transform: rotate(180deg);\n    }\n\n    &.position-right-alignment {\n      right: 25%;\n    }\n\n    i {\n      animation: right 1s infinite;\n      display: block;\n      color: #fff !important;\n    }\n\n    @keyframes right {\n      0% {\n        transform: translateX(5px);\n        opacity: 0;\n      }\n\n      100% {\n        transform: translateX(0px);\n        opacity: 1;\n      }\n    }\n\n    @keyframes left {\n      0% {\n        transform: translateX(-5px);\n        opacity: 0;\n      }\n\n      100% {\n        transform: translateX(0px);\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.ValueYourTradeInfoSlide::-webkit-scrollbar {\n  width: 3px;\n}\n\n.ValueYourTradeInfoSlide::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.ValueYourTradeInfoSlide::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.ValueYourTradeInfoSlide::-webkit-scrollbar-thumb:hover {\n  background: #888;\n}\n\n.overlay_section {\n  position: fixed;\n  height: 100vh;\n  z-index: -1;\n  clear: both;\n  bottom: 0;\n  left: 0;\n}\n\n.widget_close_toggle {\n  .icon_close_btn {\n    width: 25px;\n    height: 5vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px 0 0 5px;\n    cursor: pointer;\n\n    i {\n      font-size: 13px;\n      display: block;\n      color: #fff !important;\n    }\n\n    &.position-left-alignment {\n      i {\n        transform: rotate(180deg);\n      }\n    }\n  }\n}\n\n@media (min-width: 1900px) {\n  .ValueYourTradeInfoSlide .nav_header {\n    h5 {\n      font-size: 16px;\n    }\n  }\n}\n\n@media (min-width: 2500px) {\n  .ValueYourTradeInfoSlide .nav_header {\n    h5 {\n      font-size: 20px;\n    }\n  }\n}\n\n.scroll_to_bottom {\n  position: sticky;\n  max-width: 50px;\n  text-align: center;\n  margin: 10px auto;\n  bottom: 5px;\n  color: #fff;\n  font-size: 13px;\n  border-radius: 5px;\n  cursor: pointer;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n",".ValueYourTradeInfoSlide {\n  height: 100%;\n  width: 0%;\n  position: fixed;\n  z-index: 1;\n  bottom: 0;\n  background-color: #fff;\n  overflow-x: hidden;\n  transition: 0.5s;\n  box-shadow: inset -9px -20px 11px 0px #eeeeeefc, -3px -3px 3px 0px #eeeeee52;\n  border-top: 1px solid rgba(0, 0, 0, 0.095) !important;\n  overflow-y: auto;\n}\n.ValueYourTradeInfoSlide.position-left-alignment {\n  left: 25%;\n}\n.ValueYourTradeInfoSlide.position-right-alignment {\n  right: 25%;\n}\n.ValueYourTradeInfoSlide .nav_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 5vh;\n  border-bottom: 1px solid #eee;\n  position: sticky;\n  top: 0;\n  z-index: 99;\n  background: #fff;\n}\n.ValueYourTradeInfoSlide .nav_header h5 {\n  font-size: 12px;\n  font-weight: 600;\n}\n.ValueYourTradeInfoSlide .nav_header i {\n  font-size: 11px !important;\n  color: #d9d9d9;\n  transition: transform 1s ease;\n  display: block;\n}\n.widget_open_toggle .icon_btn {\n  position: fixed;\n  top: 30%;\n  width: 25px;\n  height: 5vh;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px 0 0 5px;\n  cursor: pointer;\n}\n.widget_open_toggle .icon_btn.position-left-alignment {\n  left: 25%;\n  transform: rotate(180deg);\n}\n.widget_open_toggle .icon_btn.position-right-alignment {\n  right: 25%;\n}\n.widget_open_toggle .icon_btn i {\n  animation: right 1s infinite;\n  display: block;\n  color: #fff !important;\n}\n@keyframes right {\n  0% {\n    transform: translateX(5px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0px);\n    opacity: 1;\n  }\n}\n@keyframes left {\n  0% {\n    transform: translateX(-5px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0px);\n    opacity: 1;\n  }\n}\n.ValueYourTradeInfoSlide::-webkit-scrollbar {\n  width: 3px;\n}\n.ValueYourTradeInfoSlide::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n.ValueYourTradeInfoSlide::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n.ValueYourTradeInfoSlide::-webkit-scrollbar-thumb:hover {\n  background: #888;\n}\n.overlay_section {\n  position: fixed;\n  height: 100vh;\n  z-index: -1;\n  clear: both;\n  bottom: 0;\n  left: 0;\n}\n.widget_close_toggle .icon_close_btn {\n  width: 25px;\n  height: 5vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px 0 0 5px;\n  cursor: pointer;\n}\n.widget_close_toggle .icon_close_btn i {\n  font-size: 13px;\n  display: block;\n  color: #fff !important;\n}\n.widget_close_toggle .icon_close_btn.position-left-alignment i {\n  transform: rotate(180deg);\n}\n@media (min-width: 1900px) {\n  .ValueYourTradeInfoSlide .nav_header h5 {\n    font-size: 16px;\n  }\n}\n@media (min-width: 2500px) {\n  .ValueYourTradeInfoSlide .nav_header h5 {\n    font-size: 20px;\n  }\n}\n.scroll_to_bottom {\n  position: sticky;\n  max-width: 50px;\n  text-align: center;\n  margin: 10px auto;\n  bottom: 5px;\n  color: #fff;\n  font-size: 13px;\n  border-radius: 5px;\n  cursor: pointer;\n  height: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
